'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var action = function action(_handler) {
  return {
    name: _handler,
    handler: function handler(data) {
      return fetch(window.location.href, {
        method: 'POST',
        body: getFormData(data),
        headers: {
          'X-OCTOBER-REQUEST-HANDLER': formatHandler(_handler),
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }
  };
};

var formatHandler = function formatHandler(str) {
  var handler = str.charAt(0).toUpperCase() + str.slice(1); //capitalize
  return 'cart::on' + handler;
};

var getFormData = function getFormData(object) {
  return Object.keys(object).reduce(function (formData, key) {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());
};

exports.default = action;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/action.js
// module id = 255
// module chunks = 0